/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ComponentClassResponseDto
 */
export interface ComponentClassResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ComponentClassResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ComponentClassResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ComponentClassResponseDto
     */
    name: string;
    /**
     * Description of the component class
     * @type {string}
     * @memberof ComponentClassResponseDto
     */
    description?: string | null;
    /**
     * List of synonyms for this component class
     * @type {Array<string>}
     * @memberof ComponentClassResponseDto
     */
    synonyms: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ComponentClassResponseDto
     */
    parentId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ComponentClassResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ComponentClassResponseDto
     */
    updatedAt: Date;
    /**
     * Array of component-type IDs referencing this component class
     * @type {Array<string>}
     * @memberof ComponentClassResponseDto
     */
    componentTypes?: Array<string>;
}

/**
 * Check if a given object implements the ComponentClassResponseDto interface.
 */
export function instanceOfComponentClassResponseDto(value: object): value is ComponentClassResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('synonyms' in value) || value['synonyms'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ComponentClassResponseDtoFromJSON(json: any): ComponentClassResponseDto {
    return ComponentClassResponseDtoFromJSONTyped(json, false);
}

export function ComponentClassResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComponentClassResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'synonyms': json['synonyms'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'componentTypes': json['componentTypes'] == null ? undefined : json['componentTypes'],
    };
}

export function ComponentClassResponseDtoToJSON(json: any): ComponentClassResponseDto {
    return ComponentClassResponseDtoToJSONTyped(json, false);
}

export function ComponentClassResponseDtoToJSONTyped(value?: ComponentClassResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'description': value['description'],
        'synonyms': value['synonyms'],
        'parentId': value['parentId'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'componentTypes': value['componentTypes'],
    };
}

